package horcrux.frontend.common.views.collections.importdocuments

import horcrux.common.extensions.head
import horcrux.common.types.NonEmptyMap.Companion.nonEmptyMapOf
import horcrux.frontend.common.DocumentInputData
import horcrux.frontend.common.DocumentInputDataByClientSideIDState
import mui.material.ToggleButton
import mui.material.ToggleButtonGroup
import react.FC
import react.Props

external interface DocumentInputTypeToggleProps : Props {
    var documentInputDataByClientSideIDState: DocumentInputDataByClientSideIDState
}

val DocumentInputTypeToggle = FC<DocumentInputTypeToggleProps> { props ->
    val firstDocumentInputMaybe = props.documentInputDataByClientSideIDState.get().head.second.documentInputMaybe
    ToggleButtonGroup {
        this.value = firstDocumentInputMaybe.documentInputType
        this.exclusive = true
        this.onChange = { _, newDocumentInputTypeMaybe: DocumentInputType? ->
            newDocumentInputTypeMaybe?.let { newDocumentInputType ->
                props.documentInputDataByClientSideIDState.update {
                    val documentInputData = DocumentInputData(newDocumentInputType.getDocumentInputMaybe())
                    nonEmptyMapOf(documentInputData.rawDocumentClientSideID to documentInputData)
                }
            }
        }
        for (documentInputType in DocumentInputType.valuesList) {
            ToggleButton {
                +documentInputType.stringValue
                this.value = documentInputType
            }
        }
    }
}
